export default "__VITE_ASSET__DFm$77ej__"